import { defineMessages } from 'react-intl'

const scope = 'app.containers.Users'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Users',
  },
  columns: {
    firstName: {
      id: `${scope}.columns.firstName`,
      defaultMessage: 'First Name',
    },
    lastName: {
      id: `${scope}.columns.lastName`,
      defaultMessage: 'Last Name',
    },
    email: {
      id: `${scope}.columns.email`,
      defaultMessage: 'User Email',
    },
    organization: {
      id: `${scope}.columns.organization`,
      defaultMessage: 'Organization',
    },
    actions: {
      id: `${scope}.columns.actions`,
      defaultMessage: 'Actions',
    },
  },
  actions: {
    edit: {
      id: `${scope}.actions.edit`,
      defaultMessage: 'Edit',
    },
    delete: {
      id: `${scope}.actions.delete`,
      defaultMessage: 'Delete',
    },
    managedByOrganization: {
      id: `${scope}.actions.managedByOrganization`,
      defaultMessage: 'Managed by organization',
    },
  },
})
